module.exports = __webpack_public_path__ + "static/img/icon12.9747aa54.png";